import { render, staticRenderFns } from "./veHqWeixiuShow.vue?vue&type=template&id=12af24c8&scoped=true"
import script from "./veHqWeixiuShow.vue?vue&type=script&lang=js"
export * from "./veHqWeixiuShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12af24c8",
  null
  
)

export default component.exports